import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gastos-subcategoria',
  templateUrl: './gastos-subcategoria.component.html',
  styleUrls: ['./gastos-subcategoria.component.scss']
})
export class GastosSubcategoriaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/gastos/gastos-subcategoria/gastos-subcategoria.component.ts